import { AssetType, SymbolTypes, OptionExpirationType, OptionType } from '@tradingblock/types';
import _ from 'lodash';
import { SymbolsWithAMPMExpirations } from '../constants';
import { isString } from '../utilities';
export var AssetTypeToSymbolType = function AssetTypeToSymbolType(assType) {
  switch (assType) {
    case AssetType.Index:
      {
        return SymbolTypes.index;
      }

    case AssetType.Equity:
      {
        return SymbolTypes.stock;
      }

    default:
      {
        return AssetType[assType];
      }
  }
};

var isIndex = function isIndex(symbol) {
  return _.first(symbol) === '$';
};

export var isIndexSymbol = function isIndexSymbol(symbol) {
  return isString(symbol) ? isIndex(symbol) : symbol ? symbol.type === SymbolTypes.index || isIndex(symbol.symbol) : false;
};
export var toAssetSymbol = function toAssetSymbol(symbol, assetType, symbolType, partSymb) {
  return Object.assign({
    rootSymbol: symbol,
    underlyingSymbol: symbol,
    name: symbol,
    provider: ''
  }, partSymb || {}, {
    symbol: symbol,
    type: symbolType,
    assetType: assetType
  });
};
export var toAssetSymbolBySymbolType = function toAssetSymbolBySymbolType(symbol, symbolType, partSymb) {
  return toAssetSymbol(symbol, symbolType === SymbolTypes.index ? AssetType.Index : AssetType.Equity, symbolType, partSymb);
};
export var occParseRegex = /([\w]{1,4})[\s]*(\d{2})(\d{2})(\d{2})([PC])(\d*)/;
/** OCC suffix: YYMMDD + C|P + strike digits. Parsing from the right avoids greedy root capture eating the first digit of the date when the root is not space-separated (e.g. VIX241119C00025000). */

var occTailRegex = /(\d{2})(\d{2})(\d{2})([PC])(\d+)\s*$/i;

var isAmPmUnderlyingSymbol = function isAmPmUnderlyingSymbol(underlyingSymbol) {
  var u = underlyingSymbol.trim();
  return SymbolsWithAMPMExpirations.some(function (s) {
    return s === u || _.replace(s, '$', '').toLowerCase() === u.replace(/^\$/, '').toLowerCase();
  });
};

export var isOCCSymbol = function isOCCSymbol(occSymbol) {
  return parseOccSymbol(occSymbol).assetType === AssetType.Option;
};
export var deriveRootSymbol = function deriveRootSymbol(symbol) {
  var parsed = parseOccSymbol(symbol);
  return parsed.assetType === AssetType.Option ? parsed.symbol : symbol;
};
export var deriveOptionExpirationType = function deriveOptionExpirationType(symbol, underlyingSymbol) {
  if (isOCCSymbol(symbol)) {
    if (isAmPmUnderlyingSymbol(underlyingSymbol)) {
      var cleanRootSymbol = deriveRootSymbol(symbol).trim().toLocaleLowerCase();

      var cleanUnderlying = _.replace(underlyingSymbol, '$', '').trim().toLocaleLowerCase();

      return cleanRootSymbol !== cleanUnderlying ? OptionExpirationType.PM : OptionExpirationType.AM;
    } else {
      return OptionExpirationType.PM;
    }
  }

  return undefined;
};
export var isSymbolEqual = function isSymbolEqual(one, two) {
  if (_.isNil(one) || _.isNil(two)) {
    return false;
  }

  return one.underlyingSymbol === two.underlyingSymbol && one.rootSymbol === two.rootSymbol && one.symbol === two.symbol;
};
export var parseOccSymbol = function parseOccSymbol(occSymbol) {
  if (!isString(occSymbol) || !occSymbol.trim()) {
    return {
      symbol: occSymbol || '',
      assetType: AssetType.Equity
    };
  }

  var normalized = _.trim(_.replace(occSymbol, /^\./, ''));

  var tailMatch = normalized.match(occTailRegex);

  if (tailMatch && tailMatch.index !== undefined && tailMatch.index > 0) {
    var root = _.trim(normalized.slice(0, tailMatch.index));

    if (root.length > 0) {
      var yy = tailMatch[1];
      var mm = tailMatch[2];
      var dd = tailMatch[3];
      var callput = tailMatch[4];
      var price = tailMatch[5];
      var year = 2000 + parseInt(yy, 10);
      var month = parseInt(mm, 10) - 1;
      var day = parseInt(dd, 10);

      var rootSymbol = _.trim(_.replace(root, /^\$/, ''));

      return {
        symbol: rootSymbol,
        expiration: new Date(year, month, day),
        option: callput.toLowerCase() === 'p' ? OptionType.Put : OptionType.Call,
        strike: parseInt(price, 10) / 1000,
        assetType: AssetType.Option
      };
    }
  }

  var data = normalized.match(occParseRegex);

  if (data && data.length >= 5) {
    var symbol = data[1];

    var _year = 2000 + parseInt(data[2], 10);

    var _month = parseInt(data[3], 10) - 1;

    var _day = parseInt(data[4], 10);

    var _callput = data[5];
    var _price = data[6];
    return {
      symbol: symbol,
      expiration: new Date(_year, _month, _day),
      option: _callput ? _callput.toLocaleLowerCase() === 'p' ? OptionType.Put : OptionType.Call : undefined,
      strike: _price ? parseInt(_price, 10) / 1000 : undefined,
      assetType: AssetType.Option
    };
  }

  return {
    symbol: occSymbol,
    assetType: AssetType.Equity
  };
};
export function isOptionSymbol(val) {
  return parseOccSymbol(val).assetType === AssetType.Option;
}
export function isOptionAsset(val) {
  return val.assetType === AssetType.Option;
}
export function isMutualFundSymbol(val) {
  return val.startsWith(':');
}